import { ModalTypes } from "../TargetTypeManagement";
import { getDeletePopup } from "../../../view/popup/PopupContainer";
import { removeLocationList } from "../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../validation/ToastContainer";

export class LocationManager {

    constructor(setModalProps, setModalType, setShowModal, setPopup, elements) {
        this.setShowProps = setModalProps;
        this.setModalType = setModalType;
        this.setShowModal = setShowModal;
        this.setPopup = setPopup;
        this.elements = elements;
    }

    showAddModal = () => {
        this.setModalType(ModalTypes.CREATE);
        this.setShowModal(true);
    }

    showEditModal = () => {

        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;

        const modalProps = {
            title: "Edit Location",
            text: "Select Location",
            elements: this.elements,
            onClick: (element) => {
                setModalProps({ selectedLocation: element })
                setModalType(ModalTypes.EDIT);
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.SELECT);
        setShowModal(true);

    }

    showRemoveModal = () => {


        const setModalProps = this.setShowProps;
        const setModalType = this.setModalType;
        const setShowModal = this.setShowModal;
        const setPopup = this.setPopup;

        const modalProps = {
            title: "Remove Location",
            text: "Select Locations",
            elements: this.elements,
            onSubmit: (locations) => {
                setPopup(
                    getDeletePopup('Are you sure you want to remove the selected locations?',
                        'Remove Locations',
                        () => removeLocationList(locations)
                            .then((errors) => {
                                setShowModal(false);
                                if (errors.length > 0) {
                                    errors.forEach(errMessage => {
                                        showDangerToast(errMessage, "Error", "Unable to delete Location");
                                    })
                                } else {
                                    showSuccessToast("Locations were not removed", "Remove Locations")
                                }
                            }),
                        undefined,
                        'Remove Locations'
                    ))
            }
        }

        setModalProps(modalProps);
        setModalType(ModalTypes.REMOVE);
        setShowModal(true);

    }
}
